export default __webpack_public_path__ + "static/media/Fog-Only.083feb58.png";